import React, { useState, useEffect, useRef } from "react"
import _get from "lodash/get"
import _isEmpty from "lodash/isEmpty"
import { NumericFormat } from "react-number-format"
import { useTranslation } from "next-i18next"

import useSmartCrop from "@/hooks/useSmartCrop"
import SocialShare from "@/components/SocialShare/v1/SocialShare"
import { getConfig } from "@/constants/config"
import { useDispatch, useSelector } from "react-redux"
import { addMedia, removeItems } from "@/store/features/favoritesSlice"
// import { addToCart } from "@Store/actions"
import { connect } from "react-redux"
import SmartCropImage from "@/components/core/SmartCropImage"
import {
  getShortenedUrl,
  getAsFinalPrice,
  getCustomerGroup,
  getAsPrice,
  getShortenedUrlwithGeneral,
} from "@/utils/helper"
import {
  addDataLayer,
  getSocialAnalyticsData,
} from "@/components/InspirationLanding/analytics"

import { getPDPUrl } from "@/utils/helper"
import MissingImage from "@/public/images/image-missing.png"
import printIcon from "@/public/icons/print.svg"
import shareIcon from "@/public/icons/share.svg"
import wishIcon from "@/public/icons/wish.svg"
import filledWishIcon from "@/public/icons/wishlist-gray-filled.svg"
import Button from "@/components/core/Button/Button"
import {
  selectAuthState,
  setAuthModalVisibility,
} from "@/store/features/authSlice"
import { showToast, selectGenericState } from "@/store/features/genericSlice"

const InspirationDetailView = ({
  selectedInspiration,
  productData,
  staticTexts,
  i18n,
  componentProps,
  sku,
  ...props
}) => {
  const [showSocialLink, setShowSocialLink] = useState(false)
  const [displayPrint, setDisplayPrint] = useState(false)
  const [displayShare, setDisplayShare] = useState(false)
  const [brandName, setBrandName] = useState("")
  const [currencySign, setCurrencySign] = useState("")
  const [inspirationUrl, setInspirationUrl] = useState("")
  const [cartUrl, setCartUrl] = useState("")
  const [shortendPagePath, setShortendPagePath] = useState("")
  const { isAuth, access_token: accessToken } = useSelector(selectAuthState)
  const { toaster = {} } = useSelector(selectGenericState)
  const [general, setGeneral] = useState()
  const shareImg = useRef(null)
  useEffect(() => {
    getConfig().then(async CONFIG => {
      setBrandName(CONFIG?.general?.siteName.toLowerCase() ?? "")
      setInspirationUrl(CONFIG?.general.inspirationDetailPath)
      setCurrencySign(_get(CONFIG, "internationalization.currencySign", ""))
      setGeneral(CONFIG?.general)
      getShortenedUrl(_get(CONFIG, "general.cartLandingPagePath", "")).then(
        ret => {
          setCartUrl(ret)
        }
      )

      setShortendPagePath(CONFIG?.general?.shortendPagePath)
    })
  }, [])

  const shortendcustomCtaLink = componentProps?.customCtaLink.replace(
    shortendPagePath,
    ""
  )
  const shortendreplaceAddToCartCtaLink =
    componentProps?.replaceAddToCartCtaLink?.replace(shortendPagePath, "") || ""

  const dispatch = useDispatch()
  const [loginFavouriteCallback, setLoginFavouriteCallback] = useState(null)

  const [toasters, setToaster] = useState({
    show: false,
    message: "",
    isError: false,
  })
  const smartCrop = useSmartCrop()
  const { t } = useTranslation()
  const { isOverlay = false } = props
  const imageName = selectedInspiration.url_s.split("/")[6]
  const isFavorite = props.favorites?.find(
    vl => vl.name["en-US"] === selectedInspiration.id
  )
    ? true
    : false
  const { customerGroup = "", fallbackCustomerGroup = "" } = getCustomerGroup()

  const [pdpNavigationURL, setPdpNavigationURL] = useState("")

  useEffect(() => {
    const isDisplaySharePrint = () => {
      const el =
        document.querySelector("[data-component='InspirationDetail']") ?? ""
      if (el) {
        const staticText = JSON?.parse(el?.dataset?.staticText)

        setDisplayShare(staticText.enableFavorite === "true" ? true : false)
        setDisplayPrint(staticText.enablePrint === "true" ? true : false)
      }
    }
    isDisplaySharePrint()
  }, [])
  useEffect(() => {
    async function fetchPDPUrls() {
      for (const product of productData) {
        const imageVariant = sku.includes(product.masterVariant.sku)
          ? product.masterVariant
          : product.variants.filter(item => sku.includes(item.sku))[0]

        if (imageVariant && imageVariant.attributes.length !== 0) {
          let ProdCatgory = ""
          imageVariant.attributes.forEach(value => {
            if (value.name === "ProductLocalCategory") {
              ProdCatgory = value.value
            }
          })

          await getPDPUrl(ProdCatgory, product.slug["en-US"]).then(res =>
            setPdpNavigationURL(res)
          )
        }
      }
    }
    fetchPDPUrls()
  }, [productData, sku])
  const printPDP = () => {
    let printNoteLen = document.getElementsByClassName(
      "product-details__print-note"
    ).length
    if (printNoteLen === 0) {
      const printNote = `<div class='product-details__print-note'><div class='container'><div class='row'><div class='col-12'><h6>${staticTexts.priceFootnoteTitle}</h6><p>${staticTexts.priceFootnote}</p><h6>${staticTexts.colorFootnoteTitle}</h6> <p>${staticTexts.colorFootnote}</p></div></div></div></div>`
      let printNoteDiv = document.createElement("div")
      printNoteDiv.innerHTML = printNote
      document.body.appendChild(printNoteDiv)
    }
    addDataLayer({
      title: staticTexts.print.toLowerCase(),
      imageName: `${imageName.toLowerCase()}`,
      isOverlay: isOverlay,
      cart_ID: props?.cart?.id,
    })
    window.print()
  }

  const addToCart = async product => {
    const quantity = 1
    const result = await props.addToCart(
      [
        {
          sku: product.masterVariant.sku,
          quantity: quantity,
          isBundle: false,
          brand: brandName,
        },
      ],
      false,
      null,
      null,
      true
    )
    showToaster(result.message, result.status)
    addDataLayer({
      title: componentProps?.ctaLabel.toLowerCase(),
      imageName: `${imageName.toLowerCase()}`,
      isOverlay: isOverlay,
      productInfo: props?.getVarientProductInfo(product),
      cart_ID: props?.cart?.id,
    })
  }

  const showToaster = (message, status) => {
    if (status == 200 || status == 201) {
      setToaster({
        ...toasters,
        show: true,
        message,
        isError: false,
      })
    } else {
      setToaster({
        ...toasters,
        show: true,
        message,
        isError: true,
      })
    }
    setTimeout(
      () =>
        setToaster({ ...toasters, show: false, message: "", isError: false }),
      3000
    )
  }

  const handleCallBack = () => {
    addDataLayer({
      title: isFavorite ? "remove favorite" : "add favorite",
      imageName: `${imageName.toLowerCase()}`,
      isFavorite: true,
      isOverlay: isOverlay,
      cart_ID: props?.cart?.id,
    })
  }

  const customOrderClickHandler = text => {
    addDataLayer({
      title: text ? text : staticTexts.customOrderContactUs.toLowerCase(),
      imageName: `${imageName.toLowerCase()}`,
      isOverlay: isOverlay,
      url: text
        ? shortendreplaceAddToCartCtaLink
        : `${componentProps?.customCtaLink}`,
      cart_ID: props?.cart?.id,
    })
  }

  const sampleCardClickHandler = (url, data) => {
    addDataLayer({
      title: "sample navigation",
      imageName: `${imageName.toLowerCase()}`,
      isOverlay: isOverlay,
      tileName: data.name["en-US"].toLowerCase(),
      url: `${url}`,
      productInfo: props?.getVarientProductInfo(data),
      cart_ID: props?.cart?.id,
    })
  }

  const customOrderImageClickHandler = url => {
    addDataLayer({
      title: "custom order sample image",
      imageName: `${imageName.toLowerCase()}`,
      isOverlay: isOverlay,
      url: `${url}`,
      cart_ID: props?.cart?.id,
    })
  }
  const handleLogin = e => {
    e.preventDefault()
    e.stopPropagation()
    window.loginFavouriteCallback = () => {
      setLoginFavouriteCallback(e)
    }
    dispatch(setAuthModalVisibility({ show: true }))
  }
  const handleFavorite = e => {
    e.preventDefault()
    e.stopPropagation()
    if (isFavorite === true) {
      props.favorites?.map(fav => {
        if (fav.name["en-US"] === selectedInspiration.id) {
          if (!isAuth) {
            handleLogin(e)
          } else {
            dispatch(removeItems({ ids: [fav.id], isDataLayerNeeded: false }))
              .unwrap()
              .then(() => {
                handleCallBack()
                dispatch(
                  showToast({
                    message:
                      getShortenedUrlwithGeneral(
                        toaster?.content?.unfavoriteSuccessMessage,
                        general
                      ) || staticTexts?.removeItem,
                    isVisible: true,
                  })
                )
              })
              .catch(err => {
                dispatch(
                  showToast({
                    message: staticTexts.removeItemError,
                    isVisible: true,
                  })
                )
                handleCallBack()
              })
          }
        }
      })
    } else {
      if (!isAuth) {
        handleLogin(e)
      } else {
        const payload = {
          type: "image",
          name: selectedInspiration?.id,
          url: selectedInspiration?.url_s,
        }
        dispatch(addMedia(payload))
          .unwrap()
          .then(() => {
            handleCallBack()
            dispatch(
              showToast({
                message:
                  getShortenedUrlwithGeneral(
                    toaster?.content?.successMessage,
                    general
                  ) || staticTexts.favSuccessMsg,
                isVisible: true,
              })
            )
          })
          .catch(err => {
            dispatch(
              showToast({
                message: staticTexts.favErrorMsg,
                isVisible: true,
              })
            )
            handleCallBack()
          })
      }
    }
  }

  let itemCountMessage = `${1} ${t("kf.pdp.label.itemAdded")} `
  let addTocartFailureMessage = `${1} ${t("kf.pdp.label.itemAddedFailed")} `

  const ToasterMssg = () => (
    <>
      {toasters.isError ? addTocartFailureMessage : itemCountMessage}
      {toasters.isError == false && (
        <span>
          <a href={cartUrl}>{t("kf.pdp.label.yourCart")}</a>.
        </span>
      )}
    </>
  )

  return (
    <div className="inspiration-detail">
      {/* {toasters.show && (
        <Toaster
          message={<ToasterMssg />}
          onClose={() =>
            this.setState({ toasters: { show: false, message: "" } })
          }
        />
      )} */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-lg-7 col-md-6 col-sm-6">
            <div className="inspiration-detail__gallery">
              <div className="inspiration-detail-tile">
                {componentProps?.enableFavorite && (
                  <div className="inspiration-detail-tile__share">
                    <div
                      className="inspiration-detail-tile__share-icon"
                      onClick={handleFavorite}
                    >
                      <img
                        src={isFavorite ? filledWishIcon.src : wishIcon.src}
                        alt={staticTexts.wishlist}
                      />
                    </div>
                  </div>
                )}
                <div className="inspiration-detail-tile__image">
                  <div
                    className="inspiration-detail-tile__image gbh-data-layer"
                    data-gbh-data-layer={
                      '{"eventAction":"inspiration landing navigation","eventName":"inspiration landing navigation","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' +
                      selectedInspiration.id +
                      '","internalLinkPosition":"inspiration","internalLinkType":"inspiration:navigation","internalLinkZoneName":"inspiration:promo tiles","clickInternalLinks":"true","frequency":"n/a","productColor":"n/a","productCoupondiscount":"n/a","productID":""}'
                    }
                  >
                    <SmartCropImage
                      url={selectedInspiration["url_s"]}
                      altText={selectedInspiration["title_s"] || ""}
                      smartCrop={smartCrop}
                      key={selectedInspiration["thumbnailImageURL_s"]}
                    />
                  </div>
                </div>
              </div>
              <div className="print-share">
                <div className="print-and-share">
                  {displayPrint && (
                    <div
                      className="print-button"
                      tabIndex="0"
                      role="button"
                      onClick={() => printPDP()}
                    >
                      {" "}
                      <img
                        className="print-image"
                        src={printIcon.src}
                        alt={staticTexts.print}
                      />
                      <span aria-hidden="true" tabIndex="-1">
                        {staticTexts.print}{" "}
                      </span>
                    </div>
                  )}
                  {displayShare && (
                    <div
                      className="share-button"
                      onClick={() => setShowSocialLink(!showSocialLink)}
                      ref={shareImg}
                      tabIndex="0"
                      role="button"
                    >
                      <img
                        className="share-image"
                        src={shareIcon.src}
                        alt={staticTexts.share}
                      />
                      <span aria-hidden="true" tabIndex="-1">
                        {staticTexts.share}
                      </span>
                      <SocialShare
                        showModal={showSocialLink}
                        id="kf-product-detail"
                        onClose={() => {
                          setShowSocialLink(false)
                          shareImg?.current.focus()
                        }}
                        shareBtn={shareImg}
                        url={`${window.location.origin}${inspirationUrl}?q=${selectedInspiration?.id}`}
                        analyticData={JSON.parse(
                          getSocialAnalyticsData({
                            title: staticTexts.share.toLowerCase(),
                            isOverlay: isOverlay,
                            imageName: imageName,
                          })
                        )}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-5 col-md-6 col-sm-6 product-details__content-section print-overview-right">
            <div className="inspiration-detail__cart">
              {productData.length > 0 && (
                <div className="order-sample__heading">
                  {componentProps?.sectionLabel}
                </div>
              )}
              <div className="order-sample__body">
                {productData.map((product, key) => {
                  let imageVariant = sku.includes(product.masterVariant.sku)
                    ? product.masterVariant
                    : product.variants.filter(item => sku.includes(item.sku))[0]

                  const priceData = getAsPrice(
                    [imageVariant],
                    ["stand-alone-price", "prices"],
                    customerGroup,
                    fallbackCustomerGroup
                  )
                  const finalPrice = getAsFinalPrice(
                    priceData[imageVariant.sku],
                    true
                  )
                    ? getAsFinalPrice(priceData[imageVariant.sku], true)
                    : getAsFinalPrice(priceData[imageVariant.sku], null)
                  if (imageVariant && imageVariant.attributes.length !== 0) {
                    let displayName = imageVariant.attributes.filter(value => {
                      if (value.name === "ProductBrandNameDisplay") {
                        return value.value
                      }
                    })
                    let ProdDesc = imageVariant.attributes.filter(value => {
                      if (value.name === "ProductDescriptionProductShort") {
                        return value.value["en-US"]
                      }
                    })
                    let ProdCatgory = ""
                    imageVariant.attributes.filter(value => {
                      if (value.name === "ProductLocalCategory") {
                        ProdCatgory = value.value
                      }
                    })
                    let isSample = ProdCatgory?.toLowerCase() === "samples"

                    return (
                      <div key={key} className="order-sample__card">
                        <a
                          href={`${pdpNavigationURL}?skuId=${imageVariant.sku}`}
                          rel="noopener noreferrer"
                          onClick={() =>
                            sampleCardClickHandler(pdpNavigationURL, product)
                          }
                        >
                          <img
                            key={product.id}
                            onError={e => (e.target.src = MissingImage)}
                            src={
                              imageVariant.images[0]?.url || MissingImage.src
                            }
                            className="order-sample__image"
                            alt={
                              displayName[0]?.value ??
                              ProdDesc[0]?.value["en-US"] ??
                              ""
                            }
                          />
                        </a>
                        <div className="order-sample__name">
                          {displayName ? displayName[0]?.value : ""}
                        </div>
                        <div className="order-sample__description">
                          {ProdDesc ? ProdDesc[0]?.value["en-US"] : ""}
                        </div>
                        {!isSample && finalPrice && (
                          <div className="order-sample__price">
                            <NumericFormat
                              value={finalPrice ? finalPrice : 0}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={currencySign}
                              decimalScale={2}
                              fixedDecimalScale={true}
                            />
                          </div>
                        )}
                        {/* <div className='order-sample__price' >{`${currencySign} `}{product.masterVariant.prices[0] ? parseFloat(product.masterVariant.prices[0]?.discounted?.value?.centAmount/100).toFixed(2) : '0.00'}</div> */}
                        <div>
                          {componentProps?.disableEcommerce &&
                            componentProps?.replaceAddToCart && (
                              <a href={shortendreplaceAddToCartCtaLink}>
                                <button
                                  className="kf-react-button button small secondary order-sample__button"
                                  size="small"
                                  label={
                                    componentProps?.replaceAddToCartCtaLabel
                                  }
                                  target={
                                    componentProps?.ecomLinkNewTab
                                      ? "_blank"
                                      : "_self"
                                  }
                                  onClick={() =>
                                    customOrderClickHandler(
                                      componentProps?.replaceAddToCartCtaLabel
                                    )
                                  }
                                >
                                  {componentProps?.replaceAddToCartCtaLabel}
                                </button>
                              </a>
                            )}

                          {!componentProps?.disableEcommerce && (
                            <button
                              disabled={
                                !imageVariant?.availability?.channels[
                                  Object.keys(
                                    imageVariant?.availability?.channels
                                  )[0]
                                ].isOnStock
                              }
                              className="order-sample__button"
                              onClick={() => addToCart(product)}
                            >
                              {componentProps?.ctaLabel}
                            </button>
                          )}
                        </div>
                      </div>
                    )
                  }
                })}
              </div>
              {selectedInspiration.customSampleProductName_s && (
                <>
                  <div className="order-sample__heading">
                    {" "}
                    {componentProps?.customSectionLabel}
                  </div>
                  <div className="order-sample__body">
                    <div className="order-sample__card">
                      <div className="product-tile__badge">
                        {!_isEmpty(selectedInspiration.badge_s) && (
                          <p className="product-tile__new">
                            {selectedInspiration.badge_s}
                          </p>
                        )}
                      </div>
                      <a
                        href={selectedInspiration.url_s}
                        rel="noopener noreferrer"
                      >
                        <img
                          onError={e => (e.target.src = MissingImage)}
                          src={selectedInspiration?.url_s || MissingImage.src}
                          className="order-sample__image"
                          alt={selectedInspiration.title_s}
                          onClick={() =>
                            customOrderImageClickHandler(
                              selectedInspiration.url_s
                            )
                          }
                        />
                      </a>
                      <div className="order-sample__name">
                        {" "}
                        {selectedInspiration.customSampleProductName_s}
                      </div>
                      <div className="order-sample__name">
                        {selectedInspiration.title_s}
                      </div>
                      <div className="order-sample__description">
                        {selectedInspiration.description_s}
                      </div>
                      <div>
                        <a
                          href={shortendcustomCtaLink}
                          rel="noopener noreferrer"
                        >
                          <button
                            className="order-sample__button"
                            onClick={() => customOrderClickHandler(null)}
                          >
                            {staticTexts.customOrderContactUs}
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default InspirationDetailView
